import { render, staticRenderFns } from "./DashEmpty.vue?vue&type=template&id=73093655&"
import script from "./DashEmpty.vue?vue&type=script&lang=js&"
export * from "./DashEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports